import { Injectable } from '@angular/core';
import { HttpEvent } from '@angular/common/http';

import { Observable } from 'rxjs';

import { BaseMiscDomainService } from 'src/app/_common/domain/base-misc-domain.service';
import { MediaTypes } from 'src/app/_common/services/files.service';
import { ChargedCapacityMiscApiService } from '../api/charged-capacity-misc-api.service';


@Injectable({
    providedIn: 'root'
})
export class ChargedCapacityMiscDomainService extends BaseMiscDomainService
{
    constructor(
        private chargedCapacityMiscApiService: ChargedCapacityMiscApiService
    )
    {
        super();
    }

    export (qs: string, format: MediaTypes): Observable<HttpEvent<Blob>>
    {
        return this.chargedCapacityMiscApiService.export(qs, format);
    }
}
